var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass2",
    serifid: "magnifying-glass"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-tracking",
    x: 0,
    y: 0,
    width: 24,
    height: 23.983,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.334,16.721c-0.014,-0.019 -0.036,-0.03 -0.06,-0.03l-1.087,-0c-0.363,-0 -0.663,-0.299 -0.663,-0.663c0,-0.364 0.3,-0.664 0.663,-0.664c0,0 1.456,0 1.456,0c0.209,0 0.405,0.099 0.531,0.266c-0,-0 3.169,4.226 3.169,4.226c0.086,0.114 0.133,0.254 0.133,0.397c-0,0.364 -0.3,0.664 -0.664,0.664l-17.624,-0c-0.364,-0 -0.664,-0.3 -0.664,-0.664c0,-0.143 0.047,-0.283 0.133,-0.397c-0,-0 3.169,-4.226 3.169,-4.226c0.126,-0.167 0.322,-0.266 0.531,-0.266c-0,0 1.44,0 1.44,0c0.364,0 0.663,0.3 0.663,0.664c0,0.364 -0.299,0.663 -0.663,0.663c-0,-0 -1.071,-0 -1.071,-0c-0.024,-0 -0.046,0.011 -0.06,0.03l-2.062,2.749c-0.017,0.023 -0.02,0.053 -0.007,0.079c0.013,0.025 0.039,0.041 0.067,0.041l14.672,0c0.028,0 0.054,-0.016 0.067,-0.041c0.013,-0.026 0.01,-0.056 -0.007,-0.079l-2.062,-2.749Zm-5.04,0.3c-0.09,0.049 -0.191,0.074 -0.303,0.074c-0.111,0 -0.212,-0.025 -0.303,-0.074c-0.09,-0.049 -0.163,-0.115 -0.219,-0.197l-3.818,-5.366c-0.32,-0.463 -0.563,-0.956 -0.728,-1.479c-0.166,-0.525 -0.248,-1.057 -0.248,-1.596c-0,-0.746 0.151,-1.464 0.453,-2.154c0.302,-0.69 0.742,-1.295 1.318,-1.814c0,-0 0,-0 0,-0c0.492,-0.445 1.046,-0.781 1.661,-1.008c0.614,-0.227 1.242,-0.34 1.884,-0.34c0.652,-0 1.282,0.113 1.891,0.34c0.611,0.227 1.162,0.563 1.654,1.008c0,-0 0,-0 0,-0c0.577,0.519 1.016,1.124 1.318,1.814c0.303,0.69 0.454,1.408 0.454,2.154c-0,0.539 -0.083,1.071 -0.248,1.596c-0.165,0.523 -0.408,1.016 -0.729,1.479l-3.817,5.366c-0.056,0.082 -0.129,0.148 -0.22,0.197Zm-0.242,-1.777l3.223,-4.538c0.239,-0.341 0.422,-0.711 0.55,-1.108c0.129,-0.398 0.193,-0.803 0.193,-1.215c0,-0.651 -0.15,-1.268 -0.45,-1.852c0,0 -0,0 -0,-0c-0.352,-0.669 -0.85,-1.199 -1.493,-1.589c-0.643,-0.39 -1.338,-0.585 -2.084,-0.585c-0.746,-0 -1.44,0.195 -2.084,0.585c-0.643,0.39 -1.14,0.92 -1.492,1.589c-0,0 -0.001,0 -0.001,0c-0.3,0.584 -0.45,1.201 -0.45,1.852c0,0.412 0.065,0.817 0.193,1.215c0.129,0.399 0.314,0.771 0.554,1.115l3.219,4.531c0.014,0.02 0.037,0.032 0.061,0.032c0.025,-0 0.047,-0.012 0.061,-0.032Zm1.227,-4.644c-0,0 -0.042,0.025 -0,0l-0,0c-0.392,0.229 -0.821,0.343 -1.288,0.343c-0.466,0 -0.895,-0.114 -1.287,-0.343c-0.392,-0.228 -0.702,-0.538 -0.93,-0.929c-0.228,-0.392 -0.343,-0.821 -0.343,-1.288c0,-0.466 0.115,-0.895 0.343,-1.287c0.228,-0.392 0.538,-0.702 0.93,-0.93c0.392,-0.228 0.821,-0.342 1.287,-0.342c0.467,-0 0.896,0.114 1.288,0.342c0.391,0.228 0.701,0.538 0.929,0.93c0.229,0.392 0.343,0.821 0.343,1.287c0,0.467 -0.114,0.896 -0.343,1.288c-0.228,0.391 -0.538,0.701 -0.929,0.929Zm-0.31,-3.005c0.001,-0.006 -0.086,-0.095 -0.09,-0.099c-0.246,-0.246 -0.542,-0.369 -0.888,-0.369c-0.346,0 -0.641,0.123 -0.887,0.369c-0.246,0.246 -0.369,0.542 -0.369,0.887c-0,0.346 0.123,0.642 0.369,0.888c0.246,0.246 0.541,0.369 0.887,0.369c0.346,-0 0.642,-0.123 0.888,-0.369c0.245,-0.246 0.369,-0.542 0.369,-0.888c-0,-0.3 -0.093,-0.563 -0.279,-0.788Z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRTracking);
export default __webpack_public_path__ + "static/media/iconR-tracking.3dd7702b468d233a9855284571d915af.svg";
export { ForwardRef as ReactComponent };